<template>
    <div class="animated fadeIn bgV2" v-bind:class="{'run-loading':Loadings.detail}">
        <b-row>
            <b-col md="12">
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button 
                            label="Save" 
                            @click="save" 
                            :disabled="$disabledCreateOrUpdate(this.data, $accessModule.water_meter_listing)" 
                            :loading="isAction" />
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input 
                                            label="Tag Name" 
                                            v-model="data.device_tag" />
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input 
                                            label="Serial Number" 
                                            v-model="data.serial_number" />
                                    </b-col>
                                    <b-col md="4" class="mt-30">
                                        <gofix-text-field 
                                            label="Consumption" 
                                            oneline>
                                            {{$accounting.formatNumber(data.lastLog && data.lastLog.consumption, 3, " ")}}
                                        </gofix-text-field>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-properties 
                                        label="Location" 
                                        :contract-id="ClientContractID ? ClientContractID.id : null" 
                                        search-nested 
                                        valueFormat="object" 
                                        v-model="locationSelect" 
                                        required />
                                    </b-col>
                                    <!--<b-col md="4">
                                        <div class="custom-checkbox-device">
                                            <label class="title-checkbox">Is it cumulated reading?</label>
                                            <b-form-radio-group 
                                                v-model="data.is_cumulated" 
                                                :options="[{ text: 'Yes', value: true },{ text: 'No', value: false }]" 
                                                name="radio-inline" />
                                        </div>
                                    </b-col>-->
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="3">
                                        <gofix-form-tree 
                                            label="Parent Meter" 
                                            :options="dataParentModal" 
                                            :load-options="loadParentOptions" 
                                            v-model="parentSelect" 
                                            :normalizer="normalizerParent" 
                                            search-nested 
                                            valueFormat="object" />
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-form-dropdown 
                                            label="Bypass Meter" 
                                            v-model="data.relation_type" 
                                            :options="['bypass']" />
                                    </b-col>
                                    <!--<b-col md="3">
                                        <gofix-form-input-number 
                                            label="Threshold" 
                                            :include-thousands-separator="false" 
                                            v-model="data.threshold" 
                                            :disabled="data.is_cumulated" />
                                    </b-col>-->
                                    <b-col md="3">
                                        <gofix-form-input-number 
                                            label="Threshold" 
                                            :include-thousands-separator="false" 
                                            v-model="data.threshold" />
                                    </b-col>
                                    <b-col md="3">
                                        <gofix-form-input 
                                            label="UOM" 
                                            v-model="data.unit_of_measurement" />
                                    </b-col>
                                </b-row>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};
export default {
    name: 'meter-info',
    data() {
        return {
            tabData: [{
                key: "basic-info",
                title: "Basic Info",
                active: true
            }],
            isAction: false,
            dataLocationModal: [],
            dataParentModal: [],
            locationSelect: null,
            parentSelect: null,
            data: {
                contract_id: '',
                device_tag: '',
                parent_id: '',
                location_id: '',
                relation_type: '',
                unit_of_measurement: '',
                serial_number: '',
                threshold: '',
                is_cumulated: false
            },
            pages: {
                isCMS: '1',
                page: 1,
                limit: 100,
                totalPage: 1,
                filter: JSON.parse(JSON.stringify(filters['meter_listing']))
            }
        }
    },
    created() {
        if (!this.$route.path.includes('add') && (!this.$route.params.id || isNaN(this.$route.params.id))) {
            return this.$router.push(`/v2/water-meter/`)
        }

        if (this.$route.params.id && !isNaN(this.$route.params.id)) {
            this.$store.dispatch('MeteringDevicesController/getItem', this.$route.params.id)
                .then(response => {
                    this.setData(response)
                    this.$store.dispatch('ContractController/getClientContract', response.contract_id)
                        .then(async response => {
                            if (!response.data.data.id) {
                                await this.$router.push(`/v2/water-meter/`)
                                await this.$alertNotification("Contract does not exist.", "danger");
                            }
                        })
                        .catch(async error => {
                            await this.$router.push(`/v2/water-meter/`)
                            await this.$alertNotification("Contract does not exist.", "danger");
                        })
                })
                .catch(error => {
                    this.$router.push(`/v2/water-meter/`)
                })
        }

        // get parent meter
        if (this.ClientContractID && this.ClientContractID.id) {
            this.data.contract_id = this.ClientContractID.id
            this.getLocaltion()
            this.getParent()
        }
    },
    watch: {
        ClientContractID: function(val, old) {
            if (val) {
                this.data.contract_id = val.id
                this.getLocaltion()
                this.getParent()
            }
        }
    },
    computed: {
        ...mapGetters({
            Loadings: 'MeteringDevicesController/Loadings',
            ClientContractID: 'ContractController/ClientContractID',
            Items: 'MeteringDevicesController/Items'
        })
    },
    methods: {
        getLocaltion() {
            if (this.ClientContractID && this.ClientContractID.id) {
                global.axios(`api/contracts/${this.ClientContractID.id}/tree-properties/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                }).then(response => {
                    this.dataLocationModal = response.data.data;
                }).catch(error => reject(error));
            } else {
                this.$alertNotification("Please select one contract!!", "danger");
            }
        },
        getParent() {
            global.axios(`api/metering-devices/tree/1`, {
                method: "GET",
                params: {
                    contract_id: this.data.contract_id
                },
                headers: {
                    Accept: "application/json",
                }
            }).then(response => {
                this.dataParentModal = response.data.data
            }).catch(error => reject(error));
        },
        loadParentOptions({ action, parentNode, callback }) {
            if (action === LOAD_CHILDREN_OPTIONS) {
                if (parentNode.children) {
                    parentNode.children = parentNode.children;
                    callback();
                    return;
                }
                if (parentNode.data.isBatch) {
                    global
                        .axios(
                            `api/metering-devices/tree/${parentNode.data.id}`, {
                                method: "GET",
                                headers: {
                                    Accept: "application/json"
                                }
                            }
                        )
                        .then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data;
                                callback();
                            });
                        });
                } else {
                    parentNode.children = [];
                    callback();
                }
            }
        },
        normalizerParent(node) {
            if (node.data.isBatch)
                return {
                    id: node.data.id,
                    label: node.device_tag,
                    children: node.children,
                    isDisabled: (this.$route.params.id && !isNaN(this.$route.params.id)) && (this.$route.params.id == node.data.id) ? true : false,
                };
            return {
                id: node.data.id,
                label: node.device_tag,
                children: undefined,
                isDisabled: (this.$route.params.id && !isNaN(this.$route.params.id)) && (this.$route.params.id == node.data.id) ? true : false,
            };
        },
        setData(data) {
            if (data) {
                this.data = Object.assign(this.data, {
                    id:  data.id,
                    device_tag:  data.device_tag,
                    parent_id:   data.parent_id,
                    location_id: data.location_id,
                    unit_of_measurement: data.unit_of_measurement,
                    serial_number: data.serial_number,
                    threshold:     data.threshold ? JSON.stringify(data.threshold) : '',
                    is_cumulated:  data.is_cumulated ? data.is_cumulated : false,
                    lastLog:       data.lastLog,
                    relation_type: data.related_devices != '' ? 'bypass' : data.related_devices
                });

                if (data.properties) {
                    this.locationSelect = data.properties
                }

                if (data.metering_device && data.metering_device.id != 1) {
                    this.parentSelect = data.metering_device
                }
            }
        },
        save() {
            this.isAction = true
            if (!this.data.device_tag) {
                this.$alertNotification("Please enter Tag Name!!", "danger");

                this.isAction = false
                return false;
            }

            if (!this.ClientContractID) {
                this.$alertNotification("Please select one contract!!", "danger");

                this.isAction = false
                return false;
            }

            if (!this.locationSelect) {
                this.$alertNotification("Please select one Location!!", "danger");
                this.isAction = false
                return false;
            }

            this.data.parent_id = this.parentSelect ? this.parentSelect.id : 1;
            this.data.location_id = this.locationSelect.id
            this.data.relation_type = this.data.relation_type ? this.data.relation_type : '';

            let request = Object.assign({}, this.data);
            request.threshold = request.threshold ? Number(request.threshold) : '';

            if (this.$route.params.id && !isNaN(this.$route.params.id)) {
                this.$store.dispatch("MeteringDevicesController/updateMeteringDevice", { id: this.$route.params.id, data: request })
                    .then(async data => {
                        this.isAction = false
                        this.getParent()
                        this.$alertNotification(this.$notificationV2('editing', 'meter_reading'));
                    })
                    .catch(error => {
                        this.isAction = false
                        this.$alertNotification("Error", "danger");
                    })
            } else {
                this.$store.dispatch("MeteringDevicesController/saveMeteringDevice", request)
                    .then(async data => {
                        this.isAction = false
                        await this.$router.push(`/v2/water-meter/${data.data.data.id}`)
                        await this.getParent()
                        this.$alertNotification(this.$notificationV2('adding', 'meter_reading'));
                        this.pages.filter.contract_id.value = this.data.contract_id
                        this.$store.dispatch('MeteringDevicesController/getList', this.pages);
                        this.getParent()
                    })
                    .catch(error => {
                        this.isAction = false
                        this.$alertNotification("Error", "danger");
                    })
            }
            this.$store.dispatch('MeteringDevicesController/getList', this.Items.pages);
            this.getParent()
        }
    }
}
</script>